import merge from './util/merge'

const defaults = {
    api: '',
    format_date: date =>
        new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        }).format(date),
}

export default class Config {
    constructor(config) {
        this.config = merge(defaults, config)
    }

    all() {
        return this.config
    }

    get(propertyPath, def = null) {
        return (
            propertyPath.split('.').reduce((prev, curr) => {
                return prev ? prev[curr] : undefined
            }, this.config) || def
        )
    }
}
